<template>
  <div class="reset-password-form">
    <b-alert variant="danger" :show="hasSubmitError" dismissible>
      {{$t('resetPassword.resetLinkExpired')}}
      <router-link to="/forgotten-password">{{$t('resetPassword.clickHere')}}</router-link>
      {{$t('resetPassword.requestAnother')}}
    </b-alert>

    <b-form novalidate @submit.stop.prevent="resetPassword">
      <b-form-group
        id="password-input-group"
        :label="$t('resetPassword.passwordLabel')"
        label-for="password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="password-input"
          ref="password"
          name="password"
          v-model="password"
          v-validate="{required: true, min: 6}"
          :state="validateState('password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('resetPassword.passwordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group
        id="confirm-password-input-group"
        :label="$t('resetPassword.confirmPasswordLabel')"
        label-for="confirm-password-input"
      >
        <b-form-input
          autocomplete="off"
          type="password"
          id="confirm-password-input"
          name="confirm-password"
          v-model="confirmPassword"
          v-validate="{required: true, confirmed: 'password'}"
          :state="validateState('confirm-password')"
        >
        </b-form-input>

        <b-form-invalid-feedback>
          {{$t('resetPassword.confirmPasswordInvalid')}}
        </b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-col>
          <loading-button
            :text="$t('resetPassword.btnText')"
            :loading-text="$t('resetPassword.btnLoadingText')"
            variant="primary"
            :loading=submitting
            type="submit"
            :disabled="veeErrors.any()"
          />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import FormValidation from '../../mixins/FormValidation';

  export default {
    mixins: [FormValidation],
    props: {
      userId: {
        type: String,
        required: true,
      },
      resetCode: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        submitting: false,
        password: '',
        confirmPassword: '',
        hasSubmitError: false,
      };
    },
    methods: {
      resetPassword() {
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.submitting = true;
          this.$store.dispatch('account/resetPassword', {
            userId: this.userId,
            resetCode: this.resetCode,
            newPassword: this.password,
          }).then(() => {
            this.$toasted.success(this.$t('resetPassword.passwordReset'), {
              icon: 'check-circle',
            });
            this.$router.push('/login');
          }).catch(() => {
            this.hasSubmitError = true;
          }).finally(() => {
            this.submitting = false;
          });
        });
      },
    },
  };
</script>
